<template>
    <div class="software-content" style="height: 100%;">
        <software-statistics :softwareItem="softwareItem" ref="software_statistics" v-if="opt=='softwareStatstics'"></software-statistics>
        <my-software-detail :softwareId="softwareItem.id" ref="my_software_detail" v-else-if="opt=='softwareDetail'"></my-software-detail>
        <div style="height: 100%;" v-else>
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <div style="display: flex;">
                    <div @click="uploadResource" class="res-btn-box blue-theme">上传资源</div>
                    <!-- <div @click="batchShare" class="res-btn-box white-theme">批量共享</div> -->
                </div>
                <div style="display: flex;align-items: center;">
                    <div style="color: #8590B3;margin:0 1rem 0 3rem;">搜索</div>
                    <el-input v-model="resourceName" class="input" @keydown.enter.native="search" clearable @clear="search" style="width: 20rem;"
                        placeholder="请输入关键字">
                        <template slot="prefix">
                            <div class="search-ipt-box">
                                <img style="cursor: pointer;width: 16px;height: auto;"
                                    src="../../assets/image/magSys/search.png" @click="search" alt="">
                            </div>
                        </template>
                    </el-input>
                    <div class="btn-box" style="margin-left: 3rem;" @click.stop="openFilter">
                        <img style="margin-right: 0.5rem;width: 16px;height: auto;"
                            src="../../assets/image/magSys/filter.png" alt="">
                        软件筛选
                    </div>
                </div>
            </div>
            <div class="content-container-box">
                <div class="container-box" v-if="tableData.length > 0">
                    <div v-for="(item, index) in tableData" class="data-item" @click="view(item)" :key="index">
                        <div class="bg">
                            <el-tooltip effect="dark" content="软件统计" placement="top-start">
                                <div class="msg" @click.stop="viewStatistics(item)">
                                    <img src="../../assets/image/software/data.png" alt="">
                                </div>
                            </el-tooltip>
                            <el-dropdown class="dropdown" v-if="!['0','1'].includes(item.dataType)">
                                <div @click.stop class="better-more">
                                    <img src="../../assets/image/software/more.png" alt="">
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(el, index) in showOperation(item)"
                                        @click.native="el.method(item)" :key="index">{{ el.label }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="data-type" v-if="filterLabel(item.dataType)"
                            :style="`background-color: ${filterLabel(item.dataType).value};`">{{
                                filterLabel(item.dataType).label }}
                        </div>
                        <img class="top-img"
                            :src="item.softwareCover ? $severUrl(item.softwareCover) : $filterResDefault('虚拟仿真')" alt="">
                        <div class="bottom-content">
                            <p class="software-name">{{ item.softwareName }}</p>
                            <div class="right-area">
                                    <div class="show-item">
                                        <el-tooltip class="item" effect="dark" content="实训时长" placement="top-start">
                                            <img src="../../assets/image/software/time.png" alt="">
                                        </el-tooltip>
                                        <p>{{ item.trainingTime || 0 }}</p>
                                    </div>
                                    <div class="show-item">
                                        <el-tooltip class="item" effect="dark" content="实训人次" placement="top-start">
                                            <img style="width: 1.8rem;height: auto;"
                                                src="../../assets/image/software/person_num.png" alt="">
                                        </el-tooltip>
                                        <p>{{ item.trainingCount?(item.trainingCount+'次'):(0+'次') }}</p>
                                    </div>
                                    <div class="show-item">
                                        <el-tooltip class="item" effect="dark" content="完成率" placement="top-start">
                                            <img src="../../assets/image/software/finish.png" alt="">
                                        </el-tooltip>
                                        <p>{{ item.finishingRate + '%'}}</p>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <no-data v-else></no-data>
                <div v-if="tableData.length > 0" style="text-align: center;margin-top: 2rem;">
                    <el-pagination background @size-change="changePageSize" @current-change="changeCurrentPage"
                        :current-page="pages.current" :page-sizes="[12, 18, 24]" :page-size="pages.size"
                        layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
                    </el-pagination>
                </div>
            </div>
            <upload-software ref="upload" @create_resource="queryResource"></upload-software>
            <filter-assembly title="软件筛选" ref="filter_assembly" @change_type="changeType"
                :filterOpt="{ 'ssfl': classifyCode }"></filter-assembly>
        </div>
    </div>
</template>

<script>
import { SoftwarePageList, DelSoftware, ShareResData, CancelShareResData,QuerySoftwareDetail } from '@/api/software';
import UploadSoftware from '../common/UploadSoftware.vue';
import FilterAssembly from '../backendSys/FilterAssembly.vue';
import NoData from '../common/NoData.vue';
import SoftwareStatistics from '../backendSys/softwareMag/SoftwareStatistics.vue';
import MySoftwareDetail from './myselfSoftware/MySoftwareDetail.vue';
import Utils from '@/assets/js/Utils';

export default {
    components: { UploadSoftware, FilterAssembly, NoData, SoftwareStatistics, MySoftwareDetail },
    data() {
        return {
            classifyCode: '',
            tableData: [],
            selectIds: [],
            type: '',
            resourceName: '',
            /**当前软件 */
            softwareItem:'',
            tableKey: [
                { name: '软件名称', value: 'softwareName', },
                { name: '所属分类', value: 'classifyName' },
                { name: '上传时间', value: 'createTime' },
                { name: '操作', value: 'operation', slot: 'operation', width: 150 },
            ],
            pages: {
                current: 1,
                size: 12,
                total: 0
            },
        }
    },
    methods: {
        selectEvent(e) {
            this.selectIds = e.map(item => item.id);
        },
        /**查看软件统计数据 */
        viewStatistics(item){
            this.softwareItem=item;
            this.$store.commit('course/changeOperation','softwareStatstics');
            this.$store.commit('backend/changeOptlabel',item.softwareName);
        },
        /**控制操作按钮 */
        showOperation(item) {
            let arr = [
                {
                    label: '编辑',
                    value: 'edit',
                    method: this.edit
                },
                {
                    label: item.share ? '取消共享' : '资源共享',
                    value: item.share ? 'shareResource' : 'cancelShare',
                    method: item.share ? this.cancelShare : this.shareResource
                },
                {
                    label: '删除',
                    value: 'deleteResource',
                    method: this.deleteResource
                },
            ];
            return arr;
        },
        filterLabel(type) {
            let obj = {
                0: {
                    label: '云资源',
                    value: '#387DFF'
                },
                1: {
                    label: '校企资源',
                    value: '#FE7C4B'
                },
                2: {
                    label: '本地资源',
                    value: '#D5698A'
                }
            }
            return obj[type];
        },
        /**资源预览 */
        view(data) {
            this.$store.commit('course/changeOperation','softwareDetail');
            this.$store.commit('backend/changeOptlabel','软件详情');
            this.$nextTick(()=>{
                let dialog=this.$refs.my_software_detail;
                if(dialog){
                    dialog.softwareId=data.id;
                    dialog.getInitDetail();
                }
            })
        },
        /**打开过滤弹窗 */
        openFilter() {
            var dialog = this.$refs.filter_assembly;
            if (dialog) {
                dialog.show = !dialog.show;
            }
        },
        changeType(e) {
            var obj = { ssfl: 'classifyCode' };
            for (let key in e) {
                this[obj[key]] = e[key];
            }
            this.search();
        },
        /**批量共享 */
        batchShare() {
            if (this.selectIds.length == 0) {
                this.$msg({
                    showClose: true,
                    message: "请先选择课程",
                    type: "warning",
                });
                return;
            }
            this.$confirm('是否确认批量共享数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ShareResData({ ids: this.selectIds }).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            message: "批量共享资源成功",
                            type: "success",
                        });
                        this.queryResource();
                    }
                })
            });
        },
        /**上传资源 */
        uploadResource() {
            var dialog = this.$refs.upload;
            if (dialog) {
                dialog.dialogVisible = true;
                dialog.operation = 'add';
                dialog.title = '上传资源';
                dialog.clearFrom();
            }
        },
        /**分享资源 */
        shareResource(item) {
            this.$confirm('是否确认共享该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ShareResData({ ids: [item.id] }).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            message: "共享资源成功",
                            type: "success",
                        });
                        this.queryResource();
                    }
                })
            });
        },
        /**取消共享 */
        cancelShare(item) {
            this.$confirm('是否取消共享该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                CancelShareResData({ ids: [item.id] }).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            message: "取消共享成功",
                            type: "success",
                        });
                        this.queryResource();
                    }
                })
            });
        },
        /**编辑 */
        edit(item) {
            QuerySoftwareDetail({ id: item.id }).then(res=>{
                if(res.code==200){
                    var dialog = this.$refs.upload;
                    item=res.data;
                    if (dialog) {
                        dialog.operation = 'edit';
                        dialog.title = '修改资源';
                        dialog.resourceId = item.id;
                        dialog.dialogVisible = true;
                        dialog.form.softwareCode=item.softwareCode;
                        dialog.form.coverPath = item.softwareCover;
                        dialog.form.info = item.explainInfo;
                        dialog.form.resourceCategory = item.classify;
                        dialog.form.resourceName = item.softwareName;
                        dialog.form.resType=item.resType;
                        dialog.form.drillTarget=item.drillTarget;
                        dialog.form.drillTheory=item.drillTheory;
                        dialog.form.drillStep=item.drillStep;
                        dialog.form.drillMethodCourse=item.drillMethodCourse;
                        dialog.form.drillConclusion=item.drillConclusion;
                        dialog.form.hardwareAsk=item.hardwareAsk;
                        dialog.form.os=item.os;
                        dialog.form.regedit=item.regedit;
                        dialog.form.networkAsk=item.networkAsk;
                        this.$nextTick(()=>{
                            if(item.resType=='单机'){
                                dialog.form.regedit=item.regedit;
                                dialog.form.fileId=item.fileId;
                                dialog.form.fileName=item.url;
                                dialog.setChunkDefault();
                            }else{
                                dialog.form.url=item.url;
                            }
                        })
                    }
                }
            })
        },
        /**分页查询资源列表 */
        queryResource() {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "dataType": '',
                "resourceName": this.resourceName,
                "size": this.pages.size
            }
            SoftwarePageList(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.queryResource();
        },
        changePageSize(e) {
            this.pages.size = e;
            this.search();
        },
        /**删除资源 */
        deleteResource(item) {
            this.$confirm('是否确认删除该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                DelSoftware({ ids: [item.id] }).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            type: 'success',
                            message: '删除成功'
                        });
                        if(this.tableData.length==1&&this.pages.current>1){
                            this.pages.current--;
                        }
                        this.queryResource();
                    }
                })
            });
        },

        search() {
            this.pages.current = 1;
            this.queryResource();
        }
    },
    computed:{
            opt(){
                return this.$store.state.course.operation;
            }
        },
    mounted() {
        this.queryResource();
        Utils.$on('refresh_list',this.queryResource);
    },
    destroyed(){
            this.$store.commit('course/changeOperation','');
            this.$store.commit('backend/changeOptlabel','');
            Utils.$off('refresh_list',this.queryCourse);
        }
}
</script>

<style lang="less" scoped>
.bg {
    position: absolute;
    z-index: 10;
    top: 1rem;
    right: 0.2rem;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    &> :nth-child(n){
        margin-right: 0.8rem;
    }
}
/deep/.el-upload-dragger {
    width: 100%;
}

.operation-box {
    color: var(--blue);

    i {
        cursor: pointer;
        font-size: 16px;
    }
}

.icon-quxiaogongxiang {
    color: rgb(254, 0, 0);
}

.content-container-box {
    height: calc(100% - 2rem);
    width: calc(100% - 0.3rem);
    .container-box {
        display: flex;
        padding-top: 2rem;
        flex-wrap: wrap;
        align-content: flex-start;
        height: calc(100% - 7rem);
        overflow: auto;
        gap:2rem;
    }
}

.btn-box {
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: #387DFF;
}

.input {
    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
        padding-left: 3.5rem;
    }
}

.search-ipt-box {
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}

.dropdown {
    .better-more {
        width: 16px;
        height: 16px;
        border-radius: 0.2rem;
        background-color: rgba(0, 0, 0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 1rem;
        }
    }
}

.data-item {
    width: calc((100% - 10rem)/6);
    border-radius: 1rem;
    overflow: hidden;
    border: 1px solid #e0e8f2;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;

    &>img {
        aspect-ratio: 700 / 360; /* 直接设置宽高比 */
        width: 100%;
        object-fit: cover;
    }

    .bottom-content {
        color: #334681;
        font-size: 12px;
        font-weight: 700;
        padding: 1.5rem 1.5rem 2.5rem;

        .software-name {
            padding-bottom: 1.5rem;
            border-bottom: 1px solid #F6F7FA;
        }

        .right-area {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 1.5rem;
            }
    }
}

.data-item:hover {
    transform: translateY(-1rem);
}

.show-item {
    display: flex;
    align-items: center;
    img {
        width: 12px;
        object-fit: cover;
    }

    &> :nth-child(2) {
        color: #334681;
        margin-left: 0.5rem;
    }
}

.data-type {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    padding: 0.5rem 0.8rem;
    border-radius: 1rem 0 1rem 0;
}
.msg{
    width: 16px;
    height: 16px;
    border-radius: 0.2rem;
    background-color: rgba(0, 0, 0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 1rem;
    }
}
@media screen and (max-width:750px){
    .data-item{
        min-width: 37rem !important;
    }
}
</style>